import React, { FC } from 'react'

import { Typography } from '@mui/material'

import { calculateCurrencyMedians, getAllCurrencyValues } from '../../../../helpers/currencyCalculations'
import { Currency } from '../../../../types/Currency'

type MedianDisplayProps = {
  currency?: Currency
  currencies?: Currency[]
  t: (key: string) => string
  fontSize?: string
}

export const MedianDisplay: FC<MedianDisplayProps> = ({ currency, currencies, t, fontSize }) => {
  const allValues = getAllCurrencyValues(currency, currencies)
  const { medianUsd, medianGame, validValuesCount } = calculateCurrencyMedians(allValues)

  if (validValuesCount === 0) return null

  return (
    <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.secondary', mt: 1, fontSize: fontSize || 'inherit' }}>
      {t('live-events:bundle_median')}: ${medianUsd.toFixed(2)} | {t('live-events:bundle_median_in_game')}: {Math.round(medianGame)}
    </Typography>
  )
}
